import { computed } from 'vue'
import { useUsersStore } from '@/stores/users'

/* eslint-disable camelcase */
export interface TCollageThemes {
  themeId: string,
  themeColor: string,
  themeTabImgs: {
    index_bg: string,
  }
}

export const collageThemes: TCollageThemes[] = [
  {
    themeId: 'red',
    themeColor: '#E60000',
    themeTabImgs: {
      index_bg: require('@/assets/images/themeIcons/red_bg.png'),
    }
  },
  {
    themeId: 'blue',
    themeColor: '#0075FF',
    themeTabImgs: {
      index_bg: require('@/assets/images/themeIcons/blue_bg.png'),
    }
  },
  {
    themeId: 'orange',
    themeColor: '#F39B00',
    themeTabImgs: {
      index_bg: require('@/assets/images/themeIcons/orange_bg.png'),
    }
  }
]

const alphaToHex = (alpha: number): string => {
  const value = Math.floor(alpha * 255)
  return value.toString(16)
}

export const useThemeId = () => {
  const store = useUsersStore()

  return computed(() => collageThemes[store.themeType].themeId)
}

export const useThemeColor = () => {
  const store = useUsersStore()

  return computed(() => {
    return collageThemes[store.themeType].themeColor
  })
}

export const useThemeColorWithAlpha = (alpha: number) => {
  const store = useUsersStore()

  return computed(() => {
    return collageThemes[store.themeType].themeColor + alphaToHex(alpha)
  })
}

export const useThemeImgs = () => {
  const store = useUsersStore()

  return computed(() => {
    return collageThemes[store.themeType].themeTabImgs
  })
}

export const useSetThemeType = () => {
  const { setThemeType } = useUsersStore()
  return setThemeType
}
